import { state } from './types';

export default {
  [state.DATASETS]: [],
  [state.COLLECTION]: null,
  [state.COLLECTIONS]: [],
  [state.SELECTED_DATASETS]: [],
  [state.IS_LOADING]: false,
  [state.OBS_VAR_COUNTS]: {},
  [state.SUBJ_VAR_COUNTS]: {},
};
